export const ORIENTATION = {
    "NORMAL": "normal",
    "UPSIDE_DOWN": "up_side_down",
    "TURNED_LEFT": "turned_left",
    "TURNED_RIGHT": "turned_right",

    "PORTRAIT": 'portrait',
    "LANDSCAPE": 'landscape',
}

export const CAPTURE_METHOD = {
    "PHOTO": "PHOTO",
    "VIDEO": "VIDEO",
}

export const MAX_RECORD_DURATION = 30_000;
export const VIDEO_RECORDING_CONTENT_TYPE = "video/mp4;codecs=avc1";

export const START_RECORDING_PERCENT_FROM = 0;
export const SHOW_DEBUG = false;

